export function initLightbox(selector = '.gallery-item img, .gallery-grid img'): void {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(selector)).filter(
    (img) => Boolean(img.src || img.getAttribute('src')),
  );
  if (!images.length) return;

  let overlay = document.getElementById('lightbox') as HTMLElement | null;
  let imgEl = document.getElementById('lightbox-img') as HTMLImageElement | null;
  let current = 0;

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'lightbox';
    overlay.className = 'lightbox';
    overlay.innerHTML = `
      <button type="button" class="lightbox-close" aria-label="Chiudi">&times;</button>
      <button type="button" class="lightbox-nav lightbox-prev" aria-label="Precedente"><i class="fas fa-chevron-left"></i></button>
      <img id="lightbox-img" src="" alt="Immagine ingrandita">
      <button type="button" class="lightbox-nav lightbox-next" aria-label="Successiva"><i class="fas fa-chevron-right"></i></button>
      <div class="lightbox-counter" id="lightbox-counter"></div>
    `;
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('#lightbox-img');
  } else if (!overlay.querySelector('.lightbox-prev')) {
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'lightbox-nav lightbox-prev';
    prev.setAttribute('aria-label', 'Precedente');
    prev.innerHTML = '<i class="fas fa-chevron-left"></i>';
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'lightbox-nav lightbox-next';
    next.setAttribute('aria-label', 'Successiva');
    next.innerHTML = '<i class="fas fa-chevron-right"></i>';
    const counter = document.createElement('div');
    counter.className = 'lightbox-counter';
    counter.id = 'lightbox-counter';
    overlay.appendChild(prev);
    overlay.appendChild(next);
    overlay.appendChild(counter);
  }

  const counterEl = overlay.querySelector('#lightbox-counter') as HTMLElement | null;
  const show = (index: number) => {
    current = (index + images.length) % images.length;
    const src = images[current].getAttribute('src') || images[current].src;
    if (imgEl) {
      imgEl.classList.remove('is-loaded');
      imgEl.src = src;
      imgEl.alt = images[current].alt || 'Immagine ingrandita';
    }
    if (counterEl) counterEl.textContent = `${current + 1} / ${images.length}`;
    overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const hide = () => {
    overlay?.classList.remove('active');
    document.body.style.overflow = '';
  };

  images.forEach((img, index) => {
    const item = img.closest('.gallery-item') || img;
    item.addEventListener('click', (e) => {
      e.preventDefault();
      show(index);
    });
  });

  overlay.querySelector('.lightbox-close')?.addEventListener('click', hide);
  overlay.querySelector('.lightbox-prev')?.addEventListener('click', (e) => {
    e.stopPropagation();
    show(current - 1);
  });
  overlay.querySelector('.lightbox-next')?.addEventListener('click', (e) => {
    e.stopPropagation();
    show(current + 1);
  });
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) hide();
  });

  imgEl?.addEventListener('load', () => imgEl?.classList.add('is-loaded'));

  document.addEventListener('keydown', (e) => {
    if (!overlay?.classList.contains('active')) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });
}
